import React,{useEffect, useState} from "react";
import { Navigate, useNavigate, Link,useParams } from "react-router-dom";
import { association, officials,rules, officialtest } from "../../apis/urls";
import { $ } from "react-jquery-plugin";
import axios from "axios";
import moment from "moment";
import { Empty, message, Result } from "antd";
import { decode } from "html-entities";
import Userimg2 from '../../assets/userimg.png'



const Ruleslist =()=> {

    document.body.classList.remove("new-login-wrpr");
    let navigate = useNavigate();

    const Logout = () => {
        let urole = localStorage.getItem('userrole');

        if(urole === 'SUPERADMIN'){
            localStorage.removeItem('token');
            localStorage.removeItem('username');
            localStorage.removeItem('userid');
            localStorage.removeItem('userrole');
            localStorage.removeItem('test_attempted')
            localStorage.removeItem('association')
            localStorage.removeItem('coachId')

           
            navigate("/admin")

        }else if(urole === 'ASSOCIATION_USER'){
                localStorage.removeItem('token');
                localStorage.removeItem('username');
                localStorage.removeItem('userid');
                localStorage.removeItem('userrole');
                localStorage.removeItem('test_attempted')
                localStorage.removeItem('association')
               
                navigate("/associations/login")
    
        }else{
        let store = localStorage.getItem('token');
        // console.log('key',store)
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');
        localStorage.removeItem('userrole');
        localStorage.removeItem('test_attempted')
        localStorage.removeItem('association')

        
        navigate("/")
        }
        //window.location.href = "gisa/";
      }

    const [ ruleid,setRuleid ] = useState([]);
    const [ rulesData,setRulesData ] = useState([]);


    useEffect( ()=>{
        $('body').removeClass('').addClass('sidebar-collapsed');
        rulesListing();

        

    },[])



    let token = "Bearer "+localStorage.getItem('token');
    let tokens = localStorage.getItem('token');
   
    

    const current = new Date();
    const date = `${current.getMonth()}-${current.getDate()}-${current.getFullYear()}`;

    


    const rulesListing = ()=>{

      


        const instance = axios.create({

            baseURL: rules+"/rulelist/public",

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setRulesData(response.data.data)
            
            
          }).catch((error) =>{
            
            console.log('error',error.message)
            
          });

    }

        const [toggle, setToggle] = useState(true)


        const toggleOpenButton = () => 
        {
            $('body').removeClass('').addClass('sidebar-collapsed sidebar-active');
            setToggle(false)
        };

        const toggleCloseButton = () => 
        {
            $('body').removeClass('sidebar-active').addClass('');
            setToggle(true)

        };

    let resetPassword = () => {
        navigate('/reset_password')
    }

    const handleRegisterClick = () => {
      
        localStorage.removeItem('userisrule');
        
        // Navigate to coaches page
        navigate("/coaches");
    };
    
    
    


  



    return(
        
        
      
      
   
        
        <div className="wrapper">
        
          
           

                <div className="content-area rule-select-content" style={{ marginTop: '0px' }}>
                
                <div class="row " style={{width: '90', margin: '0px auto' }}>
					<div class="col-md-12 rule-select pl-5 mb-4" >
						<h2 class="please-register-hding">GIAA Rules Tests Registrations</h2>
					</div>
				</div>
                
                <div className="row rule-select-row" style={{width:'90%', margin:'0 auto'}}>
                    { rulesData?rulesData.map((item,index)=> (

                        <div className="col-md-4 rule-select" style={{display:'flex', justifyContent:"center", paddingBottom:30}}>
                        
                            <div class="product-card">
                                {item.image?
                                    <div class="main-images">
                                        <img id="blue" class="blue active" src={item.image?item.image:null} alt="blue" />
                                    </div>:
                                    <div class="main-images1">
                                        
                                    </div>
                                }
                                <div class="card-details" style={{marginTop:"15px"}}>
                                <span class="card_name" style={{textTransform:'uppercase'}}>{decode(item.rule_name)}</span>
                                </div>


                                <div class="color-price" style={{marginTop:"10px"}}>
                                <div class="color-option">
                                    <span class="color" style={{fontFamily:'Poppins', fontSize:15}}><i className="icon-date_range" style={{color:'#1890b3'}}></i></span>
                                    <div class="circles">
                                    <span style={{fontFamily:'Poppins', fontSize:15}}>Test Closes: {moment(item.testLastDate).format('ddd, MMM DD, YYYY')}</span>
                                    </div>
                                </div>
                                </div>
                                {/* icon-checkmark3 */}
                                <div class="color-price">
                                    <div class="color-option">
                                        <span class="color" style={{fontFamily:'Poppins', fontSize:15}}><i className="icon-baseball" style={{color:'#1890b3'}}></i></span>
                                        <div class="circles">
                                        <span style={{fontFamily:'Poppins', fontSize:15}}>{item.sport_name}</span>
                                        </div>
                                    </div>
                                    {/*
                                    <div class="price">
                                        <span class="price_num">${item.amount}</span>
                                    </div>
                                    */}
                                </div>



                                <div class="color-price">
                                   {/* <div class="color-option">
                                        <span class="color" style={{fontFamily:'Poppins', fontSize:15,display:'none'}}><i className="icon-tick" style={{color:'#1890b3', fontSize:18}}></i></span>
                                        <div class="circles" style={display:'none'}>
                                            <span style={{fontFamily:'Poppins', fontSize:15}}>{item.min_mark} Mark</span>
                                        </div>
                                </div> */}
                                    
                                </div>
                                <div class="color-price" style={{ display: 'flex', justifyContent: 'center'}}>
                                    <div class="color-option"  onClick={handleRegisterClick}>
                                      
                                            <button className="btn btn-primary btn-gisa">Register</button>
                                       
                                    </div>
                                </div>

                            
                            </div>  
                                      
                        </div>
                         
                                           

                    )):
                    <div className="nodata comingroot" style={{margin:"0 auto"}}>
                        <Empty style={{color:'#afafaf', fontWeight:900, fontSize:30}} description="Sorry! No Rules found" />
                    </div>
                    }
                </div>
                        

                </div>
            

        </div>

    )

}

export default Ruleslist